// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EV8H","index":"styles_index__2kIaO"};